<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M8.774,23.989c-0.069,0-0.139-0.003-0.208-0.01C5.118,23.52,3.135,18.72,2.425,14.38c-0.488-3.002-0.002-6.924,2.215-8.438
		c0.65-0.444,1.401-0.669,2.232-0.669c1.151,0,2.477,0.435,3.94,1.294c0.142,0.064,0.289,0.113,0.44,0.147V3.759
		c0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75v3.75c0,0.017-0.002,0.046-0.004,0.063
		c0,0.011-0.003,0.034-0.006,0.056c-0.004,0.028-0.01,0.052-0.017,0.077c-0.005,0.02-0.012,0.042-0.02,0.064
		c-0.011,0.028-0.02,0.05-0.031,0.071c-0.012,0.025-0.023,0.045-0.036,0.066c-0.01,0.017-0.024,0.036-0.038,0.056
		c-0.017,0.022-0.03,0.038-0.044,0.053c-0.021,0.022-0.037,0.038-0.055,0.054c-0.016,0.014-0.034,0.03-0.053,0.044
		c-0.023,0.017-0.043,0.03-0.065,0.042c-0.017,0.01-0.039,0.022-0.061,0.033c-0.021,0.01-0.044,0.019-0.069,0.028
		c-0.024,0.008-0.046,0.015-0.069,0.021c-0.026,0.006-0.051,0.011-0.078,0.015c-0.017,0.004-0.026,0.005-0.043,0.006
		c-0.101,0.008-0.202,0.012-0.303,0.012c-0.554,0-1.111-0.123-1.611-0.357c-0.024-0.011-0.045-0.023-0.066-0.035
		C8.844,7.146,7.766,6.775,6.881,6.775c-0.531,0-1,0.136-1.394,0.406c-1.585,1.083-1.998,4.393-1.581,6.959
		c0.771,4.711,2.713,8.067,4.833,8.349c0.007,0.001,0.023,0.001,0.04,0.001c0.095,0,0.193-0.026,0.283-0.076L11,21.427
		c0.306-0.157,0.651-0.24,0.998-0.24c0.347,0,0.693,0.083,1,0.241l1.914,0.974c0.108,0.06,0.209,0.087,0.312,0.087
		c0.02,0,0.039-0.001,0.059-0.003c2.101-0.28,4.038-3.635,4.808-8.348c0.345-2.103,0.18-4.892-0.969-6.38
		C19,7.6,18.947,7.403,18.972,7.205c0.026-0.199,0.127-0.376,0.286-0.498c0.131-0.101,0.293-0.156,0.458-0.156
		c0.234,0,0.451,0.106,0.594,0.291c1.521,1.971,1.63,5.293,1.262,7.539c-0.709,4.339-2.688,9.138-6.115,9.595
		c-0.086,0.009-0.158,0.012-0.229,0.012l0,0c-0.362,0-0.704-0.088-1.018-0.261l-1.894-0.963c-0.098-0.051-0.208-0.077-0.318-0.077
		c-0.11,0-0.219,0.026-0.316,0.076l-1.918,0.976C9.473,23.9,9.127,23.989,8.774,23.989z"/>
	<path d="M15.699,6.69c-0.258,0-0.518-0.062-0.75-0.179c-0.399-0.201-0.697-0.545-0.837-0.969C14.003,5.214,14,4.853,14.101,4.523
		c0.206-1.093,0.709-2.105,1.458-2.927c0.013-0.014,0.027-0.028,0.042-0.042c0.802-0.761,1.802-1.278,2.892-1.491
		c0.153-0.045,0.311-0.067,0.469-0.067c0.726,0,1.366,0.463,1.592,1.152c0.107,0.326,0.111,0.684,0.011,1.012
		c-0.206,1.093-0.71,2.105-1.458,2.929c-0.013,0.014-0.026,0.028-0.04,0.041c-0.805,0.762-1.805,1.278-2.893,1.492
		C16.019,6.667,15.859,6.69,15.699,6.69z M16.65,2.625c-0.56,0.624-0.934,1.39-1.082,2.215C15.56,4.882,15.55,4.921,15.536,4.96
		c-0.012,0.033-0.012,0.074,0,0.109c0.015,0.045,0.045,0.08,0.087,0.102c0.024,0.012,0.051,0.019,0.078,0.019
		c0.018,0,0.037-0.003,0.054-0.009c0.032-0.01,0.063-0.019,0.095-0.025c0.814-0.154,1.562-0.532,2.165-1.097
		c0.56-0.624,0.934-1.39,1.082-2.216c0.008-0.041,0.018-0.079,0.031-0.115c0.012-0.035,0.013-0.076,0.001-0.112
		c-0.027-0.083-0.104-0.12-0.167-0.12c-0.018,0-0.036,0.003-0.054,0.009c-0.031,0.01-0.063,0.018-0.095,0.024
		C18,1.681,17.253,2.06,16.65,2.625z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'fruit-apple',
    },
    name: {
      type: String,
      required: false,
      default: 'FruitApple',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>